import React from "react";
import { useStyles } from "./style";

const ItemWrapper = ({ title, children }) => {
  const classes = useStyles();
  return (
    <div>
      <p className={classes.title}>{title}</p>
      {children}
    </div>
  );
};

export default ItemWrapper;
